// Load the form styles
window.LoadCSS('/_resources/themes/marmalade/dist/styles/modal.css');